(function () {
  var ALLOW = 'input, textarea, select, [contenteditable="true"], .is-selectable';

  function isAllowed(node) {
    var type = document.body && document.body.dataset.pageType;
    if (type && type.indexOf('customers') === 0) return true;

    if (!node) return false;
    var el = node.nodeType === 1 ? node : node.parentElement;
    if (!el || typeof el.closest !== 'function') return false;
    return !!el.closest(ALLOW);
  }

  ['copy', 'cut'].forEach(function (name) {
    document.addEventListener(name, function (e) {
      if (!isAllowed(e.target)) e.preventDefault();
    });
  });
})();
